module.exports = "https://static.wmbcdn.com/uniweb/images/8970a3d4a7824750a47cb0b0fa839153.svg";